import React, { useState } from 'react';
import { LocalizationProvider, DatePicker } from '@mui/lab';
import { Box, FormLabel, TextField } from '@mui/material';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import { es } from 'date-fns/locale';
import { usePolicyStore } from '@store/policyStore';
import { generateDate } from '@utils/generateDate';

interface ErrorButton {
  setErrorVigencia: React.Dispatch<React.SetStateAction<boolean>>;
  setValidity: React.Dispatch<React.SetStateAction<string>>
}

export const EmisionButton: React.FC<ErrorButton> = ({ setValidity, setErrorVigencia }) => {
  const { policy, addPolicyInfo } = usePolicyStore();
  const [limit] = useState<any>({
    MaxDate: new Date().setDate(new Date().getDate() + 14),
    MinDate: new Date(),
  });
  const [errorDate, setErrorDate] = useState<{ msg: string; isError: boolean }>(
    {
      msg: '',
      isError: false,
    }
  );
  const [start, setStart] = useState(new Date());
  const {startDate} = generateDate()

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
      <FormLabel
        sx={{ fontSize: '14px', fontWeight: '400', marginBottom: '10px' }}
      >
        Fecha de Inicio de vigencia
      </FormLabel>
      <LocalizationProvider dateAdapter={AdapterDateFns} locale={es}>
        <DatePicker
          maxDate={limit.MaxDate}
          minDate={limit.MinDate}
          InputProps={{
            style: {
              borderRadius: 4,
            },
          }}
          views={['year', 'month', 'day']}
          label="DD/MM/AAAA*"
          inputFormat="dd/MM/yyyy"
          value={start}
          onChange={async (newValue) => {
            
            const date = newValue
            setStart(date)
            const day = `${date.getDate()}`.padStart(2, '0');
            const month = `${date.getMonth() + 1}`.padStart(2, '0');
            const year = date.getFullYear();
            const newValueDate = `${year}-${month}-${day}`;
            
            if (
              newValue.toISOString().split('T')[0] <
                limit.MinDate.toISOString().split('T')[0] ||
              newValue > limit.MaxDate
            ) {
              setErrorDate({
                msg: 'Por favor ingresar una fecha valida al día de hoy y menor o igual a 15 dias',
                isError: true,
              });
              setErrorVigencia(true);
              policy.start_at = startDate;
              await addPolicyInfo({ ...policy });
            } else {
              setErrorDate({
                msg: '',
                isError: false,
              });
              setErrorVigencia(false);
              setValidity(newValueDate);
              policy.start_at = newValueDate;
              await addPolicyInfo({ ...policy });
            }
          }}
          OpenPickerButtonProps={{
            style: {
              color: '#039ECC',
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              fullWidth
              error={errorDate.isError}
              helperText={errorDate.msg}
              sx={{ borderRadius: 8 }}
            />
          )}
        />
      </LocalizationProvider>
    </Box>
  );
};
